import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import upcomingVector from "assets/images/upcomingVector.svg";

function ReserveRide() {
  const navigate = useNavigate()
  const onClickRide = () =>{
    sessionStorage.clear()
    navigate('/home')
  }
  return (
    <Grid
      container
      className="boxShadowBlack padding30 margin"
      alignItems="center"
      justifyContent="space-between"
      xs={12}
    >
      <Grid item className="marginTopBottom25 textAlign" md={5}>
        <img className='w250' src={upcomingVector} alt="upcomingVector" />
      </Grid>
      <Grid item md={5}>
        <Grid item container>
          <Grid
            item
            className="textAlign"
            justifyContent="center"
            alignItems="center"
          >
            <Typography className="font20 fontMedium">
              You have no upcoming rides
            </Typography>
            <Typography className="font18 marginTop">
              Would you like to plan your next ride?
            </Typography>
            <Button 
            className="buttonSubmit"
            onClick={onClickRide} > Reserved your ride</Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ReserveRide;
